import * as React from 'react';
import { graphql, Link } from 'gatsby';
import PostLayout from '../components/post-layout';
import * as postStyles from '../post.module.css';
import Seo from '../components/seo';

const BlogPostTemplate = ({ data, location }) => {
   const {
      frontmatter,
      fields: { slug, readingTime },
      html,
   } = data.markdownRemark;
   const { siteUrl, author } = data.site.siteMetadata;

   return (
      <PostLayout
         location={location}
         siteUrl={siteUrl}
         slug={slug}
         title={frontmatter.title}
         date={frontmatter.date}
         tags={frontmatter.tags}
         cover={frontmatter.cover}
         avatar={author.avatar}
         readingTime={readingTime.text}
      >
         <Seo
            title={frontmatter.title}
            description={frontmatter.excerpt}
            cover={frontmatter.cover}
         />
         <div
            className={postStyles.content}
            id="md-content"
            dangerouslySetInnerHTML={{ __html: html }}
            itemProp="articleBody"
         />
         <section className={postStyles.previousNext}>
            {data.previous ? (
               <Link
                  to={data.previous.fields.slug}
                  itemProp="url"
                  replace={true}
               >
                  <div>
                     <svg
                        width="32"
                        height="29"
                        viewBox="0 0 32 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M14.125 1L1 14.125L14.125 27.25M31 14.125H1H31Z"
                           strokeWidth="3.5"
                           strokeLinecap="round"
                           strokeLinejoin="round"
                        />
                     </svg>

                     <span>Previous post</span>
                  </div>
                  <span>{data.previous.frontmatter.title.slice(0, 30)}...</span>
               </Link>
            ) : (
               <div></div>
            )}
            {data.next ? (
               <Link
                  to={data.next.fields.slug}
                  itemProp="url"
                  replace={true}
                  className={postStyles.nextPost}
               >
                  <div>
                     <span>Next post</span>
                     <svg
                        width="32"
                        height="29"
                        viewBox="0 0 32 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M17.875 1L31 14.125L17.875 27.25M1 14.125H31H1Z"
                           strokeWidth="3.5"
                           strokeLinecap="round"
                           strokeLinejoin="round"
                        />
                     </svg>
                  </div>
                  <span>{data.next.frontmatter.title.slice(0, 30)}...</span>
               </Link>
            ) : (
               <div></div>
            )}
         </section>
      </PostLayout>
   );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
   query BlogPostBySlug(
      $id: String!
      $previousPostId: String
      $nextPostId: String
   ) {
      site {
         siteMetadata {
            title
            siteUrl
            author {
               avatar
            }
         }
      }
      markdownRemark(id: { eq: $id }) {
         id
         excerpt(pruneLength: 160)
         html
         frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            tags
            cover
            excerpt
         }
         fields {
            slug
            readingTime {
               text
            }
         }
      }
      previous: markdownRemark(id: { eq: $previousPostId }) {
         fields {
            slug
         }
         frontmatter {
            title
         }
      }
      next: markdownRemark(id: { eq: $nextPostId }) {
         fields {
            slug
         }
         frontmatter {
            title
         }
      }
   }
`;
